import ActionTypes from '@constants/action_types.js'

export function receiveGroup(group) {
  return {
    type: ActionTypes.RECEIVE_GROUP,
    payload: group,
  }
}

export function receiveGroups(groups) {
  return {
    type: ActionTypes.RECEIVE_GROUPS,
    payload: groups,
  }
}
